/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Station_VoiceInputs */

const vi_nav_station_voice = /** @type {(inputs: Nav_Station_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lời thoại máy trạm`)
};

/**

* @param {Nav_Station_VoiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_station_voice = /** @type {((inputs?: Nav_Station_VoiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Station_VoiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_station_voice(inputs)
});